const getYoutubeEmbedUrl = (videoId: string) =>
  `https://www.youtube.com/${videoId}?autoplay=1&rel=0`;

export default getYoutubeEmbedUrl;
